class MegaMenuHover extends HTMLElement {
  constructor() {
    super();
    this.closeDelay = 180;
    this.closeTimer = null;
    this.desktopQuery = window.matchMedia('(min-width: 1200px)');
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.onPointerEnter = this.onPointerEnter.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-mega-menu-trigger]');
    this.panel = this.querySelector('[data-mega-menu-panel]');
    this.header = this.closest('.header-wrapper');

    if (!this.trigger || !this.panel) return;

    this.close();
    this.addEventListener('pointerenter', this.onPointerEnter);
    this.addEventListener('pointerleave', this.onPointerLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);
    this.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('pointerdown', this.onDocumentPointerDown);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.onPointerEnter);
    this.removeEventListener('pointerleave', this.onPointerLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
    this.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    window.clearTimeout(this.closeTimer);
  }

  onPointerEnter() {
    if (!this.desktopQuery.matches || !this.hoverQuery.matches) return;
    window.clearTimeout(this.closeTimer);
    this.open();
  }

  onPointerLeave() {
    if (!this.desktopQuery.matches || !this.hoverQuery.matches) return;
    if (this.contains(document.activeElement)) return;
    this.scheduleClose();
  }

  onFocusIn() {
    if (!this.desktopQuery.matches) return;
    window.clearTimeout(this.closeTimer);
    this.open();
  }

  onFocusOut(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;
    this.scheduleClose();
  }

  onKeyDown(event) {
    if (event.key !== 'Escape' || !this.classList.contains('is-open')) return;
    event.preventDefault();
    this.close(true);
  }

  onDocumentPointerDown(event) {
    if (!this.contains(event.target)) this.close();
  }

  scheduleClose() {
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => this.close(), this.closeDelay);
  }

  open() {
    document.querySelectorAll('mega-menu-hover.is-open').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    this.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.panel.setAttribute('aria-hidden', 'false');
    this.panel.inert = false;
    if (this.header) this.header.preventHide = true;
  }

  close(returnFocus = false) {
    if (!this.trigger || !this.panel) return;

    window.clearTimeout(this.closeTimer);
    this.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('aria-hidden', 'true');
    this.panel.inert = true;
    if (this.header) {
      this.header.preventHide = Boolean(this.header.querySelector('mega-menu-hover.is-open'));
    }
    if (returnFocus) this.trigger.focus();
  }
}

if (!customElements.get('mega-menu-hover')) {
  customElements.define('mega-menu-hover', MegaMenuHover);
}
